// contexts/AuthContext.tsx
import { createContext, useContext, useState, ReactNode } from 'react'

// Define the context type
type AuthContextType = {
  isLoggedIn: boolean
  login: () => void
  logout: () => void
}

// Create the context with a default value
const AuthContext = createContext<AuthContextType>({
  isLoggedIn: true,
  login: () => {},
  logout: () => {},
})

// Custom hook to use the auth context
export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}

// Provider component
type AuthProviderProps = {
  children: ReactNode
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false)

  const login = () => {
    setIsLoggedIn(true)
  }

  const logout = () => {
    setIsLoggedIn(false)
  }

  const value: AuthContextType = {
    isLoggedIn,
    login,
    logout,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
